import { render, staticRenderFns } from "./PayrollComponent.vue?vue&type=template&id=1694c74c"
import script from "./PayrollComponent.vue?vue&type=script&lang=js"
export * from "./PayrollComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports